import React from 'react';
import { Typography } from '@mui/material';
import { GuideSection } from '../common/GuideSection';
import { StepByStep } from '../common/StepByStep';
import { Warning } from '../common/Warning';
import { useTranslation } from '../../../i18n';

export const InviteUsersSection: React.FC = () => {
  const { t } = useTranslation();

  return (
    <GuideSection id="invite-users" title={t('guide.sections.inviteUsers')}>
      <Typography variant="body1" sx={{ mb: 2, color: '#555' }}>
        {t('guide.inviteUsers.intro')}
      </Typography>

      <StepByStep
        steps={[
          t('guide.inviteUsers.steps.s1'),
          t('guide.inviteUsers.steps.s2'),
          t('guide.inviteUsers.steps.s3'),
          t('guide.inviteUsers.steps.s4'),
          t('guide.inviteUsers.steps.s5'),
          t('guide.inviteUsers.steps.s6'),
        ]}
      />

      <Warning>{t('guide.inviteUsers.warningExpiry')}</Warning>
      <Warning>{t('guide.inviteUsers.warningUnassigned')}</Warning>
    </GuideSection>
  );
};
